import Select from './Select'

export default Select



// WEBPACK FOOTER //
// ./src/app/elements/Select/index.js